import { render, staticRenderFns } from "./ProductSection.vue?vue&type=template&id=0350157c&scoped=true&"
import script from "./ProductSection.vue?vue&type=script&lang=js&"
export * from "./ProductSection.vue?vue&type=script&lang=js&"
import style0 from "./ProductSection.vue?vue&type=style&index=0&id=0350157c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0350157c",
  null
  
)

export default component.exports